
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header mfp-header">
                <div class="d-flex justify-content-between">
                    <h4 class="d-inline-block align-self-center mb-0">Employees</h4>
                    <div class="d-inline-block">
                        <select class="form-select" [(ngModel)]="Prefilter">
                            <option *ngFor="let prefilter of Prefilters" [value]="prefilter.Value">{{ prefilter.Text }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="list-group">
                <div class="list-group-item">
                    <data-table-filter [config]="TableConfig" [prefilter]="Prefilter" (filterChange)="Filter = $event"></data-table-filter>
                </div>
                <div class="list-group-item">
                    <button type="button" class="btn btn-secondary mx-1" (click)="CreateEmployee()">New</button>
                    <button type="button" class="btn btn-secondary mx-1" (click)="EditEmployee()">Edit</button>
                    <button type="button" class="btn btn-secondary mx-1" (click)="SetCredentials()">Set Credentials</button>
                    <button type="button" class="btn btn-secondary mx-1" (click)="ManageDepartments()">Manage Departments</button>
                </div>
                <div class="list-group-item">
                    <div class="overflow-auto">
                        <data-table [config]="TableConfig"
                                    [Filter]="Filter"
                                    [PageSize]="30">
                        </data-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>